import React, { useEffect, useState } from 'react';
import HandleForm from './HandleForm';
import { SubmitHandler } from 'react-hook-form';
import { Grid, Link, Stack, Typography } from '@mui/material';
import IndicatorChip from '../common/ActionChip/IndicatorChip';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { TicketFormModel, TicketUpdateFormModel } from '../../models/ticket.model';
import { createTicketUpdate, getTicketUpdate } from '../../services/ticket.service';
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext';
import { useNotification } from '../../context/NotificationContext';


export default function TicketUpdateForm(props: any) {
  const {
    setBlockScreen,
    action,
    ticket_number,
    update_number } = props

  const navigate = useNavigate()
  const { selectedProject } = useProject()
  const { showNotification } = useNotification();

  const [ticketUpdateForm, setTicketUpdateForm] = useState<TicketUpdateFormModel>({
    number: '',
    created_by: {},
    created_date: '',
    title: '',
    date: '',
    priority: '',
    status_n: '',
    description: '',
    element: '',
    alarms: [],
    company: '',
    area: '',
    technician: '',
    attachment: {},
    custom_fields: {},
    project_code: selectedProject
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setTicketUpdateForm(ticketUpdateForm => ({
      ...ticketUpdateForm,
      [event.target.name]: event.target.value
    }));
  };

  const handleSelection = (key: string, value: string): void => {
    setTicketUpdateForm(ticketUpdateForm => ({
      ...ticketUpdateForm,
      [key]: value
    }));
  };

  const handleCustomFieldChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setTicketUpdateForm(prevForm => ({
      ...prevForm,
      custom_fields: {
        ...prevForm.custom_fields,
        [event.target.name]: {
        ...prevForm.custom_fields[event.target.name], 
        value: event.target.value,
        }
      }
    }));
  };

  const initComponent = () => {
    setBlockScreen(true);
    if (action === 'view' || action === 'create') {
      Promise.all([getTicketUpdate(selectedProject, ticket_number, update_number)]).then(function (results: TicketUpdateFormModel[]) {
        if (action === 'create') {
          results[0].description = ''
          results[0].attachment = {}
          results[0].project_code = selectedProject
        }
        setTicketUpdateForm(prevForm => ({
          ...prevForm,
          ...results[0],
        }));
        setBlockScreen(false);
      }).catch((error) => {
        showNotification(error.response.data, 'error')
        setBlockScreen(false);
      });
    }
  };

  useEffect(initComponent, [action]);

  const onSubmit: SubmitHandler<TicketFormModel> = () => {
    setBlockScreen(true);
    Promise.all([createTicketUpdate(selectedProject, ticket_number, ticketUpdateForm)]).then(function (results) {
      let path = `/${selectedProject}/ticket/view/${ticket_number}/1`;
      showNotification(<Typography component='span'>
        <i>Ver Actualización </i>
        <Link
          sx={{ color: 'darkblue', fontWeight: 'bold', fontStyle: 'italic' }}
          underline="hover"
          href={`/${selectedProject}/ticket/update/view/${ticket_number}/${results[0]['update_number']}`}
        >
          {`${ticket_number} #${results[0]['update_number']}`}
        </Link>
      </Typography>)
      setBlockScreen(false);
      navigate(path)
    }).catch((error) => {
      showNotification(error.response.data.error, 'error')
      setBlockScreen(false);
    });
  };

  return (
    <React.Fragment>
      {action === 'view' && (
        <Grid container margin={'2vh 0vw'} rowSpacing={'2vh'} columnSpacing={'2vw'}>

          <Grid item xs={12} md={'auto'}>

            <Stack direction="row" spacing={'0.5vw'} rowGap={1} flexWrap={'wrap'}>
              <IndicatorChip
                label={`Actualizado por ${ticketUpdateForm.created_by?.label}`}
                iconDecoration={<PersonOutlineOutlinedIcon />}
              />
              <IndicatorChip
                label={`Fecha ${ticketUpdateForm.created_date}`}
                iconDecoration={<EventAvailableOutlinedIcon />}
              />

            </Stack>
          </Grid>

        </Grid>
      )}

      <HandleForm
        action={action}
        ticketUpdateForm={ticketUpdateForm}
        onSubmit={onSubmit}
        handleChange={handleChange}
        handleSelection={handleSelection}
        handleCustomFieldChange={handleCustomFieldChange}
        selectedProject={selectedProject ? selectedProject : ticket_number.substring(0, 2)}
      />

    </React.Fragment>
  );
}